import { Palette } from '@/themes/themeOverrides/Palette';

export const Typography = {
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontSize: 16,
    color: Palette.black,
    h1: {
        fontSize: 48,
        fontFamily: 'Rubik, Arial, sans-serif',
        fontWeight: 700,
    },
    h2: {
        fontSize: 40,
        fontFamily: 'Rubik, Arial, sans-serif',
        fontWeight: 700,
    },
    h3: {
        fontSize: 34,
        fontFamily: 'Rubik, Arial, sans-serif',
        fontWeight: 700,
    },
    h4: {
        fontSize: 28,
        fontFamily: 'Rubik, Arial, sans-serif',
        fontWeight: 700,
    },
    h5: {
        fontSize: 24,
        fontFamily: 'Rubik, Arial, sans-serif',
        fontWeight: 700,
        letterSpacing: '-0.44px',
    },
    h6: {
        fontSize: 18,
        fontFamily: 'Rubik, Arial, sans-serif',
        fontWeight: 700,
        letterSpacing: '-0.36px',
        lineHeight: '24px',
    },
    subtitle1: {
        fontSize: 12,
    },
};
